import type { PortalNavItem } from '../types/portal';
import type { OnboardingSection } from '../types/onboarding';
import type { MedicationsData } from '../types/medications';

/**
 * Looks up a portal nav item and its linked onboarding section.
 */
export function findNavItemAndSection(
  routeId: string,
  navItems: PortalNavItem[],
  sections: OnboardingSection[]
) {
  const navItem = navItems.find(n => n.id === routeId);
  const editSection = navItem?.editSectionId
    ? sections.find(s => s.id === navItem.editSectionId)
    : undefined;
  return { navItem, editSection };
}

/**
 * Extracts up to 3 display names from medications and supplements.
 * Takes up to 2 from each category, then limits to 3 total.
 */
export function computeTopNames(data: Pick<MedicationsData, 'medications' | 'supplements'>): string[] {
  return [
    ...data.medications.slice(0, 2).map(m => m.medicationName),
    ...data.supplements.slice(0, 2).map(s => s.supplementName),
  ].slice(0, 3);
}
